import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const TrinidadandTobago: Country = {
    identifier: "TrinidadandTobago",
    name: "Trinidad and Tobago",
    countryCode: "TT",
    group: CountryGroup.CENTRAL_AMERICA,
    isUNMember: true,
    flag: "🇹🇹",
    svgPath: "m 304.38375,431.5574 -0.153,0.028 0.018,-0.113 0.268,-0.195 0.41,-0.132 0.104,-0.005 -0.059,0.175 -0.588,0.242 z m -0.718,2.963 -0.455,0.159 -1.186,0.038 -0.491,-0.058 -0.377,0.045 0.687,-0.347 0.081,-0.146 0.292,-0.027 0.083,-0.044 0.097,-0.767 -0.038,-0.183 -0.058,-0.101 -0.118,-0.073 -0.265,-0.099 -0.044,-0.053 0.167,-0.085 0.356,-0.047 0.266,-0.092 0.551,-0.019 0.268,-0.082 0.451,-0.023 -0.222,0.353 -0.104,0.131 0.041,0.317 -0.051,0.215 0.059,0.272 0.135,0.179 -0.087,0.175 -0.013,0.266 -0.025,0.096 z",
}
